import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig, AUTH_REDIRECT_ATTEMPT_KEY } from 'authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
    event.payload
  ) {
    const result = event.payload as AuthenticationResult;
    if (result.account) {
      msalInstance.setActiveAccount(result.account);
    }
    // Successful auth clears the auth-error redirect guard.
    sessionStorage.removeItem(AUTH_REDIRECT_ATTEMPT_KEY);
  }
});
